<template>
  <div class="c-requestAddFooter">
    <div class="c-requestAddFooter_rule">
      <p class="c-requestAddFooter_ruleTitle">公開依頼のルール</p>
      <ul>
        <li>
          ・本ページではサービス出品はできません（<a
            href="/services/add"
            target="_blank"
            rel="noopener"
          >出品はこちら</a>）。
        </li>
        <li>・オンラインで完結できる内容で投稿してください。</li>
        <li>・リアルで会うことや、物を送ることが前提のサービスは投稿できません。</li>
        <li>・直接電話やEメール、SNS、Zoomなどの外部ツールを用いたやりとりは禁止です。</li>
        <li>
          ・ガイドラインに違反した投稿は非表示にする場合があります（<a
            :href="$coconala.helpURL('/articles/218810517')"
            target="_blank"
            rel="noopener"
          >ガイドラインはこちら</a>）。
        </li>
        <li>
          ・ココナラへの<a
            href="/inquiry"
            target="_blank"
            rel="noopener"
          >ご意見・ご要望はこちら</a>。
        </li>
      </ul>
    </div>
    <div
      class="c-requestAddFooter_button"
      v-if="isPC"
    >
      <c-button-v2
        size="l"
        width="340px"
        color="primary"
        :disabled="!isValidAll"
        @click="confirm"
      >
        確認画面に進む
      </c-button-v2>
    </div>
    <div v-else-if="isSP || isTB">
      <transition name="fade">
        <div class="c-requestAddFooter_fixedButton">
          <div class="c-requestAddFooter_count">
            入力が必要な必須項目数は、残り <strong>{{ remainingCount }}</strong> です。
          </div>
          <c-button-v2
            size="m"
            width="100%"
            color="primary"
            :disabled="!isValidAll"
            @click="confirm"
          >
            確認画面に進む
          </c-button-v2>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'RequestAddFooter',
  props: {
    remainingCount: {
      type: Number,
      default: 0
    },
    isValidAll: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('ui', ['isPC', 'isTB', 'isSP'])
  },
  methods: {
    confirm() {
      this.$emit('confirm')
    }
  }
}
</script>
<style lang="scss" scoped>
.c-requestAddFooter {
  a {
    @include link-effect;
  }

  &_rule {
    ul {
      margin-top: 8px;

      li {
        margin-left: 1em;
        text-indent: -1em;
      }
    }
  }

  &_ruleTitle {
    margin: 0;
    font-weight: bold;
  }
}

@media (max-width: breakpoint(Requests, M)) {
  .c-requestAddFooter {
    &_rule {
      padding: 24px 16px 90px;
      background-color: $color-gray-50;
      font-size: 12px;

      ul {
        li {
          margin-top: 4px;
        }
      }
    }

    &_fixedButton {
      position: fixed;
      bottom: 0;
      z-index: z(fixed-footer);
      padding: 8px 12px;
      width: 100%;
      border-top: 1px solid $color-gray-200;
      background-color: $color-white;
    }

    &_count {
      margin-bottom: 8px;
      border-radius: 10px;
      background-color: $color-gray-200;
      text-align: center;
      font-weight: bold;
      font-size: 11px;

      strong {
        color: $color-red-500;
        font-size: 14px;
      }
    }
  }
}

@media (min-width: breakpoint(Requests, M) + 1) {
  .c-requestAddFooter {
    margin: 0 auto;
    width: 700px;

    &_rule {
      font-size: 13px;
    }

    &_button {
      margin-top: 32px;
      text-align: center;
    }
  }
}
</style>
